"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.backofficeDashboard_en_us = void 0;
function backofficeDashboard_en_us() {
    return {
        "backoffice.dashboard.title": "Dashboard",
        "backoffice.dashboard.createcompany": "Create Company",
        "backoffice.dashboard.createcompanysub": "With a company you manage your projects, users and invoices.",
        "backoffice.dashboard.createproject": "Create Project",
        "backoffice.dashboard.createprojectsub": "You can create and book services such as CMS, OMS or the workflow engine via projects.",
        "backoffice.dashboard.completeprofile": "Complete profile",
        "backoffice.dashboard.completeprofilesub": "Please enter your first and last name so that other users can better identify you.",
        "backoffice.dashboard.gotoprofile": "Go to Profile",
        "backoffice.dashboard.gotocompany": "Go to projects",
        "backoffice.dashboard.gotocompanies": "Go to Companies",
        "backoffice.dashboard.gotoproject": "Go to \"${project}\"",
        "backoffice.dashboard.companymessage": "Click on the button to go directly to the profile of the company \"${company}\".",
        "backoffice.dashboard.projectmessage": "Click on the button to go directly to the project \"${project}\".",
        "backoffice.dashboard.recentcompany": "Last used company",
        "backoffice.dashboard.recentproject": "Last used project",
        "backoffice.dashboard.incominginvite": "Incoming invitation",
        "backoffice.dashboard.norecentproject": "No last used project Found",
        "backoffice.dashboard.norecentprojectsub": "Sadly there was no last used project found, you can create projects in companies",
        "backoffice.dashboard.companydashboard": "Company Dashboard",
        "backoffice.dashboard.projectdashboard": "Project Dashboard",
        "backoffice.dashboard.customsnackbarcontent.button": "Click here to learn more about it!",
        "backoffice.dashboard.customsnackbarcontent.text": "Backoffice was updated to version ${backofficeVersion}"
    };
}
exports.backofficeDashboard_en_us = backofficeDashboard_en_us;
